import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let END_POINT

if (window.location.protocol === 'http:') {
    END_POINT = `http://localhost:5001`
}
else {
    END_POINT = `https://${window.location.host}/api`
}

// jwtToken
const getJwtToken = () => {
    try {
        const raw = sessionStorage.getItem("clinic-application-jwt") || localStorage.getItem("clinic-application-jwt");
        if (!raw) return "";
        const userData = JSON.parse(raw);
        return userData?.token ? "Bearer " + String(userData.token) : "";
    } catch (err) {
        return "";
    }
};


export const getCalmYourEczemaNaturallyById = createAsyncThunk(
    "calmYourEczemaNaturally/getbyid",
  async (id, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${END_POINT}/calmYourEczemaNaturally/get/${id}`,{
            headers:{
                 Authorization: getJwtToken()
            }
        }
      );
      console.log(res.data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  })


export const getAllCalmYourEczemaNaturally = createAsyncThunk(
  "calmYourEczemaNaturally/getAll",
  async ({ page = 1, limit = 10, search = "" }, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${END_POINT}/calmYourEczemaNaturally/getAll`, {
        headers: {
          Authorization: getJwtToken()
        },
        params: {
          page,
          limit,
          search
        }
      });
      console.log(res.data);
      return res.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return []; // ✅ No items, return empty array instead of rejecting
      }
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);


export const createCalmYourEczemaNaturally = createAsyncThunk(
   "calmYourEczemaNaturally/create",
  async (userData,  { rejectWithValue  })  => {
    try  {
      const res  = await axios.post(`${END_POINT}/calmYourEczemaNaturally/create`, { ...userData, sourcePage: userData?.sourcePage || window.location.pathname }, {
      headers: {
        Authorization: getJwtToken()
      }
    });
      return res.data;
     } catch (error)  {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  })


export const updateCalmYourEczemaNaturallyById = createAsyncThunk(
  "calmYourEczemaNaturally/update",
  async (userData, { rejectWithValue }) => {
    try {
      console.log("createupdatetriggering", userData);
      const targetId = userData.id || userData._id;
      const res = await axios.post(`${END_POINT}/calmYourEczemaNaturally/update/${targetId}`, userData, {
      headers: {
        Authorization: getJwtToken()
      }
    });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const deleteCalmYourEczemaNaturally = createAsyncThunk(
  "calmYourEczemaNaturally/delete",
  async (id, { rejectWithValue }) => {
    try {
      const res = await axios.delete(`${END_POINT}/calmYourEczemaNaturally/delete/${id}`,{
        headers: {
          Authorization: getJwtToken()
        }
      });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);